import { useQuery } from '@tanstack/react-query';
import { api } from '../../../../services/api';
import type { StorageFile } from '../../../../components/storage/types';

// Re-exported so existing source wrappers keep importing StorageFile from here.
export type { StorageFile } from '../../../../components/storage/types';

type StorageProvider = 'ftp' | 'sftp' | 's3' | 's3qumulo' | 'dropbox';

function normalize(data: any): StorageFile[] {
  const files: any[] = data?.files ?? [];
  return files
    .filter(f => !f.isParentDirectory)
    .map(f => {
      const path = f.path ?? f.relativePath ?? '';
      return {
        name: f.name ?? f.relativePath ?? path,
        path,
        isDirectory: f.isDirectory ?? (typeof path === 'string' && path.endsWith('/')),
        size: f.bytes ?? f.byteSize,
      };
    });
}

export function useStorageListing(
  provider: StorageProvider | null,
  params: Record<string, string | number | boolean>,
  enabled: boolean,
) {
  return useQuery({
    queryKey: ['storage', provider, params],
    queryFn: () => {
      const qs = new URLSearchParams();
      Object.entries(params).forEach(([k, v]) => {
        if (v !== undefined && v !== null) qs.set(k, String(v));
      });
      return api.get<any>(`/storage/${provider}?${qs}`).then(normalize);
    },
    enabled: !!provider && enabled,
    retry: false,
    staleTime: 0,
  });
}
